var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostrarPlano
    ? _c("div", { staticClass: "chat-message-plano mb-4" }, [
        _c(
          "button",
          {
            staticClass:
              "chat-message-plano__header d-flex align-center az-gap-small px-4 py-3 w-100 text-left",
            attrs: { "aria-expanded": _vm.planoAberto ? "true" : "false" },
            on: { click: _vm.togglePlano }
          },
          [
            _c("icon-svg", {
              staticClass: "chat-message-plano__icone flex-shrink-0",
              class: { "chat-message-plano__icone--ativo": _vm.ativo },
              attrs: {
                name: "ai-sparkle",
                size: 16,
                color: "primary",
                "data-test": "plano-icone"
              }
            }),
            _c(
              "span",
              {
                staticClass:
                  "chat-message-plano__label az-text-primary az-size-14 font-weight-medium",
                attrs: { "data-test": "plano-titulo" }
              },
              [_vm._v(_vm._s(_vm.titulo))]
            ),
            _c(
              "span",
              {
                staticClass: "az-text-secondary az-size-12 az-muted",
                attrs: { "data-test": "plano-resumo" }
              },
              [_vm._v(_vm._s(_vm.resumoDasEtapas))]
            ),
            _c("icon-svg", {
              staticClass: "chat-message-plano__chevron",
              class: {
                "chat-message-plano__chevron--expanded": _vm.planoAberto
              },
              attrs: {
                name: "arrow-down-light",
                size: 14,
                color: "var(--neutral-600)"
              }
            })
          ],
          1
        ),
        _vm.planoAberto
          ? _c(
              "div",
              { staticClass: "chat-message-plano__body px-4 py-3" },
              [
                _c("PainelSecaoProgresso", {
                  attrs: { passos: _vm.passos, "sem-titulo": "" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }